import { useMemo } from "react";

import { getDataSourceStore } from "src/utils/devextreme-grid";
import api, { useSWR } from "../utils/axios";

import { HOST_API } from "../config-global";

export const endpoint = "equipments";

const baseUrl = `/api/${endpoint}/`;

export function getGrid(typeId) {
  return getDataSourceStore(`${HOST_API}${baseUrl}get-grid/${typeId}`);
}

export function getGridFilter(filters) {
  return getDataSourceStore(`${HOST_API}${baseUrl}get-grid-list`, {}, filters);
}

export function remove(id) {
  return api.delete(`${baseUrl}${id}`);
}

export function restore(id) {
  return api.put(`${baseUrl}restore/${id}`, null);
}

export function create(data) {
  return api.post(`${baseUrl}`, data);
}

export function update(id, data) {
  return api.put(`${baseUrl}update/${id}`, { ...data });
}

export function getById(id) {
  return api.get(`${baseUrl}${id}`);
}

export function getUndelete(id) {
  return api.get(`${baseUrl}get-undelete/${id}`);
}

export function getByKey(key) {
  return api.get(`${baseUrl}${key}/key`);
}

export function getList(search, tool, locationId, isAvailable, typeKey, workOrderId = null) {
  return api.post(`${baseUrl}get-list`, {
    search,
    tool,
    locationId,
    isAvailable,
    typeKey,
    workOrderId,
  });
}

export function useGetEquipment(id) {
  const url = `${baseUrl}${id}`;

  const { data, isLoading, error, isValidating, mutate } = useSWR(id ? url : null);

  const memoizedValue = useMemo(
    () => ({
      asset: data ? { ...data } : null,
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}
